import { render, staticRenderFns } from "./HuTermsOfUse.vue?vue&type=template&id=619ec4e8&scoped=true"
import script from "./HuTermsOfUse.vue?vue&type=script&lang=js"
export * from "./HuTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "619ec4e8",
  null
  ,true
)

export default component.exports